//third party imports
import { Component, OnInit, OnDestroy, input, signal, WritableSignal, ChangeDetectionStrategy, effect } from '@angular/core';
import { Platform } from '@angular/cdk/platform';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MsalService } from '@azure/msal-angular';

//local imports
import { Messenger, ProtectedResources, Transforms} from '@app/shared';
import { UnityConfig } from './unity-configuration';

declare var createUnityInstance: any;

export interface UnityParams {
  key: string,
  value: string
}

@Component({
  selector: 'unity',
  templateUrl: './unity.component.html',
  styleUrls: ['./unity.component.css'],
  standalone: false,  
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnityComponent implements OnDestroy {

  private _destroying$ = new Subject<void>();
  
  public config = input.required<UnityConfig>();
  public width = input<string>("1500px");
  public height = input<string>("400px");    
  public params = input<UnityParams[]>([]);
  public showFullscreenButton = input(false, {
      transform: Transforms.toBoolean,
  });
  
  public isLoading: WritableSignal<boolean> = signal<boolean>(false);  
  public cacheContext = input<any>(undefined);
  
  private  messages = [];

  constructor(private platform: Platform) {

      effect(() => 
      {
        let context = this.cacheContext();
        
        let cache = this.cacheContext();

        if (!context) return;        
        if (!cache) return;

        this.isLoading.set(true);
    
        let unityLogo: HTMLElement = document.querySelector("#unity-webgl-logo");
        unityLogo.style.display = "none";

        let fullscreenButton: HTMLElement = document.querySelector("#unity-fullscreen-button");
        fullscreenButton.style.visibility = "hidden";
        fullscreenButton.style.float = "right";
        fullscreenButton.style.position = "relative";
        fullscreenButton.style.zIndex = "100";
            
        setTimeout(() => this.init(), 500);


      });
  }

  private init() {
    console.log('init unity component');



    let canvasPlaceholder: HTMLElement = document.querySelector("#unity-canvas-placeholder");
    
    canvasPlaceholder.style.height = "100%";
    canvasPlaceholder.style.width = "100%";

    let unityContext = this.cacheContext();

    if (!unityContext.canvas) {
      // UnityComponent a new canvas instance if it doesn't exist
      unityContext.canvas = document.createElement('canvas');
      unityContext.canvas.setAttribute("id", "unity-canvas");

      canvasPlaceholder.appendChild(unityContext.canvas);
    }
    else {
      unityContext.canvas.style.display = "block";
      canvasPlaceholder.appendChild(unityContext.canvas);
    }

    let container: HTMLElement = document.querySelector("#unity-container");

    container.style.width = this.width();
    container.style.height = this.height();

    let progressBarFull: HTMLElement = document.querySelector("#unity-progress-bar-full");
    let warningBanner: HTMLElement = document.querySelector("#unity-warning");    
    
    unityContext.canvas.style.width = "100%"
    unityContext.canvas.style.height = "100%"
    
    if (this.platform.ANDROID || this.platform.IOS) {

      //container.className = "unity-mobile";
      //config.devicePixelRatio = 1;
      warningBanner.style.display = "block";

      setTimeout(() => { warningBanner.style.display = "none"; }, 5000);
    }

    let loadingBar: HTMLElement = document.querySelector("#unity-loading-bar");
    loadingBar.style.display = "none";

    //#region Get refresh token from local storage - TODO replace with a better approach?
    
    // let refreshToken;
    // let keys = Object.keys(localStorage);
    // let refreshTokenKey = keys.find(key => key.includes('refreshtoken'));

    // if (refreshTokenKey) {
    //   let refreshTokenValue = localStorage.getItem(refreshTokenKey);
      

    //   refreshToken = JSON.parse(refreshTokenValue);
    
    //   if (refreshToken && refreshToken.secret) {
    //     console.log("Secret found.");
    //   } else {
    //     console.log('No secret found in the token');
    //   }

    // } else {
    //   console.log('No key found that includes "refreshtoken"');
    // }
    //#endregion
    

    if (unityContext.instance != undefined) {
      
      let params = this.params();

      if (params) {
        params.forEach(param => {
          unityContext.instance.SendMessage("WebDataTransfer", param.key, param.value);
          console.log("Param sent: " + param.key + " : " + param.value);
        });
      }

      let fullscreenButton: HTMLElement = document.querySelector("#unity-fullscreen-button");

      if (this.showFullscreenButton) {
        fullscreenButton.style.visibility = "visible";
      }

      fullscreenButton.onclick = () => {
        unityContext.instance.SetFullscreen(1);
      };


      this.isLoading.set(false);

    }
    else {

      console.log("Creating new unity instance");
      
      createUnityInstance(unityContext.canvas, this.config(),
        (progress) => {
          loadingBar.style.display = "block";
          progressBarFull.style.width = 100 * progress + "%";
        })
        .then((unityInstance) => {
          
          unityContext.instance = unityInstance;
          
          let params = this.params();

          if (params) {
            params.forEach(param => {
              unityContext.instance.SendMessage("WebDataTransfer", param.key, param.value);
              console.log("Param sent: " + param.key + " : " + param.value);
            });
          }

          let fullscreenButton: HTMLElement = document.querySelector("#unity-fullscreen-button");

          if (this.showFullscreenButton) {
            fullscreenButton.style.visibility = "visible";
          }
          
          fullscreenButton.onclick = () => {
            unityContext.instance.SetFullscreen(1);
          };

          loadingBar.style.display = "none";

          for(var message of this.messages)
          {
            console.log('InitializeMessage: 1 sending message to instance', message);
            unityContext.instance.SendMessage("WebDataTransfer", "BroadcastMessage", JSON.stringify(message));
          }
          this.messages = [];

          this.isLoading.set(false);
        })
        .catch((message) => {

          console.log(message);
          
          //TODO:DIW:Add error handling
          //this.messenger.send(error.error, "error");

          loadingBar.style.display = "none";
          this.isLoading.set(false);
        });
    }
  }

  public broadcastMessage(message: any)
  {
    let unityContext = this.cacheContext();
    
    if (unityContext == null || unityContext.instance == null)
    {
      this.messages.push(message);
      return;
    }

    console.log('InitializeMessage: 2 send message', message);


    unityContext?.instance?.SendMessage("WebDataTransfer", "BroadcastMessage", JSON.stringify(message));
  }


  //@HostListener('window:beforeunload')
  async ngOnDestroy() {
    this._destroying$.next();

    await this.cleanupUnity();

    this._destroying$.complete();
  }

  private async cleanupUnity() {

    let unityContext = this.cacheContext();


    if (!unityContext.instance) return;
    if (!unityContext.canvas) return;

    let fullscreenButton: HTMLElement = document.querySelector("#unity-fullscreen-button");
    fullscreenButton.remove();

    let container: HTMLElement = document.querySelector("#unity-canvas-placeholder");
    unityContext.canvas.style.display = "none";

    container.removeChild(unityContext.canvas);

    //this.dataContext.canvas.remove();

    return;



    try {
      await unityContext.instance.Quit();
    }
    finally {
      unityContext.instance = undefined;
      document.body.removeChild(unityContext.canvas);

    }
  }
}


